import DefaultExpenseCard from "./ExpenseCard";

export default DefaultExpenseCard;
